import * as React from 'react';
import { ProductBlockContainerLoader } from '../ProductBlockContainerLoader/ProductBlockContainerLoader.js';

const ProductBlockRow = ({ isLoading , children ,  })=>{
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(ProductBlockContainerLoader, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-row"
    }, children);
};

export { ProductBlockRow };
//# sourceMappingURL=ProductBlockRow.js.map
